/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Select, Store } from '@ngxs/store';
import { AppConfigState } from '../../../core/state/appConfig/app-config.state';
import { Observable } from 'rxjs';
import { BottomSheetEnabled } from '../../../types/BottomSheetEnabled';
import { PersistUserMapConfigState, ResetUserMapConfigState } from '../state/map-config.actions';
import { MapConfigState } from '../state/map-config.state';
import { AuthState } from '../../../core/security/state/authState.state';

@Component({
    selector: 'dash-gis-map-legend',
    templateUrl: './map-legend.component.html',
    styleUrls: [ './map-legend.component.scss' ]
})
export class MapLegendComponent implements OnInit, BottomSheetEnabled {
    @Select(AppConfigState.siteName) public siteName$: Observable<string>;
    @Select(AuthState.isDefaultUser) public isDefaultUser$: Observable<boolean>;
    @Select(MapConfigState.userCustom) public userCustom$: Observable<boolean>;

    @Input() legendVisible: boolean;

    /**
     * @param elementRef {ElementRef}
     * @param cdr {ChangeDetectorRef}
     * @param store {Store}
     * @param data
     */
    constructor(
        public elementRef: ElementRef,
        private cdr: ChangeDetectorRef,
        private store: Store,
        @Inject(MAT_BOTTOM_SHEET_DATA) @Optional() private data: any
    ) {
        if (this.data && this.data.legendVisible) {
            this.legendVisible = this.data.legendVisible;
            this.cdr.markForCheck();
        }
    }

    ngOnInit() {}

    saveLayers() {
        this.store.dispatch(new PersistUserMapConfigState());
    }

    resetLayers() {
        this.store.dispatch(new ResetUserMapConfigState());
    }
}
